<template>
  <div id="app">
    <div class="loading_bar" v-if="activeAPIRequests">
      <md-progress-bar class="md-accent" md-mode="indeterminate"></md-progress-bar>
    </div>

    <login v-if="session.user == null"/>

    <md-app v-if="session.user != null">

      <md-app-toolbar class="md-primary">
        <md-button class="md-icon-button" @click="showNavigation = !showNavigation" v-if="contextName !== 'Context'">
          <md-icon>menu</md-icon>
        </md-button>
        <!--<span class="md-title">Au Pair Weekend Scheduling - {{session.user.name}}</span>-->
        <span class="md-title">
          <router-link to="/">
            <img src="./assets/logo_small_white.png" style="height: 64px;">
          </router-link>
        </span>

        <div class="md-toolbar-section-end">
          <md-menu md-size="medium" md-align-trigger v-if="otherUsersImage.length > 0">
            <md-button md-menu-trigger class="md-icon-button md-raised md-accent md-with-hover">
              <md-icon>{{otherUsersImage}}</md-icon>
            </md-button>

            <md-menu-content>
              <md-list>
                <md-subheader class="md-primary">Users On Page</md-subheader>
                <md-list-item>
                  <md-icon class="md-accent">person</md-icon>
                  <span class="md-list-item-text">{{session.user.name}}</span>
                </md-list-item>

                <md-list-item v-for="user in otherUsersOnPage" :key="user">
                  <md-icon class="md-primary">person</md-icon>
                  <span class="md-list-item-text">{{user}}</span>
                </md-list-item>
              </md-list>
            </md-menu-content>
          </md-menu>

          <md-menu md-size="auto" md-align-trigger>
            <md-button md-menu-trigger>{{contextName}}</md-button>

            <md-menu-content>
              <md-menu-item to="/admin">Admin</md-menu-item>

            <md-menu-item :to="'/city/' + city.abbreviation" v-for="city in cities" :key="city.abbreviation">{{city.name}}</md-menu-item>
            </md-menu-content>
          </md-menu>

          <md-menu md-size="medium" md-align-trigger>
            <md-button md-menu-trigger class="md-icon-button md-raised md-accent">
              <md-avatar class="md-avatar-icon md-accent">{{session.user.initials}}</md-avatar>
            </md-button>

            <md-menu-content>
              <md-list>
                <md-list-item>
                  <md-icon class="md-accent">person</md-icon>
                  <div class="md-list-item-text">
                    <span>{{session.user.name}}</span>
                    <span>{{session.user.username.username}}</span>
                  </div>
                </md-list-item>
                <md-list-item to="/preferences">
                  <md-icon>settings</md-icon>
                  <span class="md-list-item-text">Preferences</span>
                </md-list-item>
                <md-list-item v-on:click="logout">
                  <md-icon>exit_to_app</md-icon>
                  <span class="md-list-item-text">Logout</span>
                </md-list-item>
              </md-list>
            </md-menu-content>
          </md-menu>
        </div>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="showNavigation" md-persistent="mini" v-if="contextName !== 'Context'">

        <md-list v-if="cityContext">
          <md-list-item :to="'/city/' + currentCity.abbreviation">
            <md-icon class="md-primary">home</md-icon>
            <span class="md-title">{{currentCity.name}}</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item :to="'/city/' + currentCity.abbreviation + '/weekend/' + nextWeekend.versionedId.id" v-if="nextWeekend !== null">
            <md-icon class="md-primary">folder_special</md-icon>
            <span class="md-list-item-text">{{nextWeekend.name}}</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item :to="'/city/' + currentCity.abbreviation + '/weekends'">
            <md-icon class="md-primary">folder</md-icon>
            <span class="md-list-item-text">Weekends</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item :to="'/city/' + currentCity.abbreviation + '/new'">
            <md-icon class="md-primary">create_new_folder</md-icon>
            <span class="md-list-item-text">New Weekend</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <!--</md-list-item>-->
          <md-list-item >
            <md-icon class="md-primary">settings</md-icon>
            <span class="md-title">Settings</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item :to="'/city/' + currentCity.abbreviation + '/settings/courses'">
            <md-icon class="md-primary">school</md-icon>
            <span class="md-list-item-text">Courses</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item :to="'/city/' + currentCity.abbreviation + '/settings/staff'">
            <md-icon class="md-primary">face</md-icon>
            <span class="md-list-item-text">Staff</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item :to="'/city/' + currentCity.abbreviation + '/settings/vehicles'">
            <md-icon class="md-primary">directions_car</md-icon>
            <span class="md-list-item-text">Vehicles</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item :to="'/city/' + currentCity.abbreviation + '/settings/locations'">
            <md-icon class="md-primary">room</md-icon>
            <span class="md-list-item-text">Locations</span>
            <div class="navItemBar"></div>
          </md-list-item>

        </md-list>

        <md-list v-if="adminContext">
          <md-list-item to="/admin">
            <md-icon class="md-primary">home</md-icon>
            <span class="md-title">{{contextName}}</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item to="/admin/cities">
            <md-icon class="md-primary">location_city</md-icon>
            <span class="md-list-item-text">Cities</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item to="/admin/users">
            <md-icon class="md-primary">supervisor_account</md-icon>
            <span class="md-list-item-text">Users</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item to="/admin/courses">
            <md-icon class="md-primary">school</md-icon>
            <span class="md-list-item-text">Global Courses</span>
            <div class="navItemBar"></div>
          </md-list-item>

          <md-list-item v-if="session.user.permissionLevel === 'SUPER_USER'">
            <md-icon class="md-primary">settings</md-icon>
            <span class="md-title">System</span>
          </md-list-item>
          <md-list-item to="/admin/activeview" v-if="session.user.permissionLevel === 'SUPER_USER'">
            <md-icon class="md-primary">track_changes</md-icon>
            <span class="md-list-item-text">Active View</span>
            <div class="navItemBar"></div>
          </md-list-item>
          <md-list-item to="/admin/security" v-if="session.user.permissionLevel === 'SUPER_USER'">
            <md-icon class="md-primary">security</md-icon>
            <span class="md-list-item-text">Security</span>
            <div class="navItemBar"></div>
          </md-list-item>

        </md-list>

      </md-app-drawer>

      <md-app-content id="content"  style="background-color: #f1f1f1f1">
        <router-view/>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
  import Login from './components/Login'

  var cityComparitor = function (a, b) {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  };

  export default {
    components: {Login},
    name: 'app',
    computed: {
      session() {
        return this.$store.state.session
      },
      cities() {
        return this.$store.state.cities
      },
      contextName() {
        return this.$store.state.contextName
      },
      adminContext() {
        return this.$store.state.contextName === 'Admin';
      },
      cityContext() {
        return this.$store.state.currentCity !== undefined;
      },
      path() {
        return this.$route.fullPath
      },
      currentCity() {
        return this.$store.state.currentCity
      },
      activeAPIRequests() {
        return this.$store.state.activeAPIRequests !== 0
      },
      softLockContext() {
        return this.$store.state.softLockContext;
      },
      otherUsersOnPage() {
        if (this.$store.state.otherUserPageLocks.onPage !== undefined) {
          return Object.keys(this.$store.state.otherUserPageLocks.onPage);
        } else {
          return [];
        }
      },
      otherUsersImage() {
        var otherUsersCount = 1;
        if (this.$store.state.otherUserPageLocks.onPage) {
          otherUsersCount = Object.keys(this.$store.state.otherUserPageLocks.onPage).length + 1;
        }
        if (otherUsersCount <= 1) {
          return "";
        } else if (otherUsersCount <= 9) {
          return "filter_" + otherUsersCount;
        } else {
          return "filter_9_plus";
        }
      },
      otherUserPageLocks() {
        return this.$store.state.otherUserPageLocks;
      },
      nextWeekend() {
        return this.$store.state.currentCityNextWeekend;
      }
    },
    data: () => ({
      showNavigation: false,
      contextSubscriptionId: undefined
    }),
    methods: {
      closeMenus() {
        this.showNavigation = false
        this.showContextSwitcher = false
      },
      logout() {
        this.$store.logout()
      }
    },
    watch: {
      path: function (newPath) {
        this.closeMenus()
      },
      session: function (newSession) {
        if (newSession.user != null) {
          this.$store.api.softLock(this.$route.fullPath, "onPage");
          this.contextSubscriptionId = this.$store.api.subscribe("SOFTLOCKS", this.$route.fullPath, softLockContext => {
            if (softLockContext.context.id === this.$route.fullPath.replace(/[^A-Za-z0-9]/g, '')) {
              this.$store.commit('setSoftLockContext', softLockContext);
            }
          });
          if (this.$route.meta.admin) {
            this.$store.commit('setContextName', "Admin");
            this.$store.commit('setCurrentCity', undefined);
          }

          this.$router.beforeEach((to, from, next) => {
            if (to.meta.admin) {
              this.$store.commit('setContextName', "Admin");
              this.$store.commit('setCurrentCity', undefined);
            }

            if (this.contextSubscriptionId !== undefined) {
              this.$store.api.unsubscribe(this.contextSubscriptionId);
              this.contextSubscriptionId = undefined;
            }

            this.$store.api.softUnlockAll(from.fullPath);
            this.$store.api.softLock(to.fullPath, "onPage");
            this.contextSubscriptionId = this.$store.api.subscribe("SOFTLOCKS", to.fullPath, softLockContext => {
              if (softLockContext.context.id === this.$route.fullPath.replace(/[^A-Za-z0-9]/g, '')) {
                this.$store.commit('setSoftLockContext', softLockContext);
              }
            });
            next();
          });
          this.$store.api.rpcRequest("getCities", {}, cities => {
            cities.sort(cityComparitor);
            this.$store.commit('setCities', cities);
          }, errorMessage => {
            console.dir("Error fetching cities" + errorMessage);
          });
        } else {
          this.$router.beforeEach((to, from, next) => {
            next();
          });
        }
      }
    }
  }
</script>


<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #content {
    min-height: calc(100vh - 64px);
  }

  .loading_bar {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    z-index: 99998
  }

  a.router-link-exact-active div.navItemBar {
    display: block;
  }

  div.navItemBar {
    background-color: black;
    height: 100%;
    width: 4px;
    position: absolute;
    top:0;
    left:0;
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue